var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEventConfirmed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4L18 4L18 2.5C18 2.22386 17.7761 2 17.5 2L16.5 2C16.2239 2 16 2.22386 16 2.5L16 4L8 4L8 2.5C8 2.22386 7.77614 2 7.5 2L6.5 2C6.22386 2 6 2.22386 6 2.5L6 4L5 4C3.89543 4 3 4.89543 3 6L3 19C3 20.1046 3.89543 21 5 21L19 21C20.1046 21 21 20.1046 21 19L21 6C21 4.89543 20.1046 4 19 4ZM19 19L5 19L5 8L19 8L19 19ZM10.59 15.85C10.6807 15.9467 10.8074 16.0015 10.94 16.0015C11.0726 16.0015 11.1993 15.9467 11.29 15.85L15.54 11.61C15.7318 11.4122 15.7318 11.0978 15.54 10.9L15 10.37C14.8022 10.1782 14.4878 10.1782 14.29 10.37L10.93 13.73L9.7 12.49C9.50219 12.2982 9.18781 12.2982 8.99 12.49L8.46 13C8.26943 13.1944 8.26943 13.5056 8.46 13.7L10.59 15.85Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEventConfirmed);
export default __webpack_public_path__ + "static/media/icon-event-confirmed.e4583092.svg";
export { ForwardRef as ReactComponent };